import { ResponseError } from '@ynap/api-utils'

import { SET_PACKAGING_OPTION_REQUEST, SET_PACKAGING_OPTION_SUCCESS, SET_PACKAGING_OPTION_ERROR } from '../constants/ActionTypes'
import GenericAction from './types/genericAction.types'

type SetPackagingOptionErrorAction = GenericAction<
    typeof SET_PACKAGING_OPTION_REQUEST | typeof SET_PACKAGING_OPTION_SUCCESS | typeof SET_PACKAGING_OPTION_ERROR,
    { error: ResponseError }
>

export default function setPackagingOptionError(state = null, action: SetPackagingOptionErrorAction) {
    switch (action.type) {
        case SET_PACKAGING_OPTION_REQUEST:
        case SET_PACKAGING_OPTION_SUCCESS:
            return null

        case SET_PACKAGING_OPTION_ERROR:
            return action.error.message

        default:
            return state
    }
}
